<div class="card-content">
    <div class="tem-card">
        <div class="tem-card__header">
            <span class="tem-card__title">{{'correios.range.title'|translateTA}}</span>
            <button nz-button nzType="primary" nzShape="circle" type="button"
                    nz-tooltip [nzTooltipTitle]="'correios.range.request'|translateTA" (click)="getRange()">
                <nz-icon nzType="plus" />
            </button>
        </div>
        <div class="tem-card__body">
            <nz-table #rangeTable [nzData]="rangeList" nzSize="small"
                      [nzShowPagination]="false" [nzNoResult]="emptyTpl" class="range-table">
                <thead>
                    <tr>
                        <th>{{'correios.range.company'|translateTA}}</th>
                        <th>{{'correios.range.mktp'|translateTA}}</th>
                        <th>{{'correios.range.service'|translateTA}}</th>
                        <th>{{'correios.range.current'|translateTA}}</th>
                        <th>{{'correios.range.start'|translateTA}}</th>
                        <th>{{'correios.range.end'|translateTA}}</th>
                        <th>{{'correios.range.acronym'|translateTA}}</th>
                        <th>{{'correios.range.codserv'|translateTA}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of rangeTable.data">
                        <td>{{item['CODECOMPANY']}}</td>
                        <td>{{item['CODEMKTP']}}</td>
                        <td>{{item['SERVICENAME']}}</td>
                        <td>{{item['ETQATU']}}</td>
                        <td>{{item['ETQINI']}}</td>
                        <td>{{item['ETQFIN']}}</td>
                        <td>{{item['SIGLA']}}</td>
                        <td>{{item['CODSERV']}}</td>
                    </tr>
                </tbody>
            </nz-table>
            <ng-template #emptyTpl>
                <nz-empty nzNotFoundImage="simple" [nzNotFoundContent]="'correios.range.empty'|translateTA"></nz-empty>
            </ng-template>
        </div>
    </div>
</div>
